import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export type PersonType = 'staff' | 'visitor' | 'courier' | 'unknown';

export const personTypes: PersonType[] = [
  'staff',
  'visitor',
  'courier',
  'unknown',
];

export const personTypesSchema = Joi.string().valid(...personTypes);

export const PERSON_IDENTIFIED = 'VISION/PERSON_IDENTIFIED';

export interface IPersonIdentifiedPayload {
  snapshotId: string;
  personType: PersonType;
  faceId: string;
}

export const personIdentifiedPayloadSchema = objectSchemaOf<
  IPersonIdentifiedPayload
>({
  snapshotId: Joi.string().required(),
  personType: personTypesSchema.required(),
  faceId: Joi.string().required(),
});

export interface IPersonIdentifiedAction {
  type: typeof PERSON_IDENTIFIED;
  payload: IPersonIdentifiedPayload;
}

export const personIdentifiedActionSchema = objectSchemaOf<
  IPersonIdentifiedAction
>({
  type: Joi.string().required().valid(PERSON_IDENTIFIED),
  payload: personIdentifiedPayloadSchema.required(),
});

export const personIdentified = actionCreator({
  type: PERSON_IDENTIFIED,
  schema: personIdentifiedActionSchema,
});
